module.exports = "<header>\r\n  <a href=\"https://supercallrecorderapp.com/\" target=\"_blank\">\r\n    <div class=\"logo-icon logo-sizing\"></div>\r\n  </a>\r\n  <div class=\"companyName\">Super Call Recorder</div>\r\n  <div class=\"menu-container\">\r\n    <button mat-icon-button [matMenuTriggerFor]=\"appMenu\" class=\"menu-icon icon-sizing\">\r\n    <mat-menu #appMenu=\"matMenu\">\r\n      <button mat-menu-item (click)=\"logout()\">Logout</button>\r\n    </mat-menu>\r\n    </button>\r\n  </div>\r\n</header>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/head/head.component.html
// module id = ./src/app/header/head/head.component.html
// module chunks = main